document.addEventListener('click', function (e) {
  const link = e.target.closest('a');
  if (!link) return;

  if (
    link.href === 'https://doctor.oralcreation.co.uk/' ||
    link.href === 'https://portal.oralcreation.co.uk/'
  ) {
    link.setAttribute('target', '_blank');
  }
});

